var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel1Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5763_120938)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.930176,
    y: 0.130859,
    width: 61.4714,
    height: 50.0553,
    rx: 25.0276,
    fill: "#F8EF07"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6918 14.1034C30.4889 12.4506 32.8428 12.4506 33.6399 14.1034L35.9284 18.8486C36.2542 19.5244 36.9031 19.9865 37.6483 20.0734L42.8981 20.6861C44.7741 20.905 45.5131 23.2361 44.1057 24.4958L40.346 27.8615C39.766 28.3806 39.5049 29.1686 39.6602 29.9315L40.6642 34.8644C41.0344 36.683 39.1177 38.1098 37.4817 37.2333L32.7008 34.672C32.0543 34.3256 31.2773 34.3256 30.6308 34.672L25.85 37.2333C24.214 38.1098 22.2973 36.683 22.6675 34.8644L23.6715 29.9315C23.8268 29.1686 23.5657 28.3806 22.9856 27.8615L19.2259 24.4958C17.8186 23.2361 18.5576 20.905 20.4336 20.6861L25.6834 20.0734C26.4286 19.9865 27.0774 19.5244 27.4033 18.8486L29.6918 14.1034Z",
    fill: "#DEAB28"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5763_120938",
    x: 0.930176,
    y: 0.130859,
    width: 61.4714,
    height: 57.0805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.0253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.937255 0 0 0 0 0.027451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5763_120938"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.0253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5763_120938",
    result: "effect2_dropShadow_5763_120938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5763_120938",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1Active);
export default __webpack_public_path__ + "static/media/Level1Active.b46ba45fbb0a3e6818389f6f4599e67f.svg";
export { ForwardRef as ReactComponent };